(() => {
  if (customElements.get("hero-slider")) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      this.viewportWidth = window.innerWidth;
      ["shopify:section:load", "load", "resize"].forEach((event) => {
        window.addEventListener(event, () => {
          if (event == "resize" && window.innerWidth == this.viewportWidth) {
            return;
          }

          this.viewportWidth = window.innerWidth;
          // this.calcMarginTop();
        });
      });
    }

    connectedCallback() {
      const swiper = new Swiper(this, {
        direction: "horizontal",
        autoplay:
          this.dataset.autoplay == "true"
            ? { delay: Number(this.dataset.autoplayInterval) }
            : false,
        grabCursor: Number(this.dataset.slidesCount) > 1,
        loop: Number(this.dataset.slidesCount) > 1,
        navigation: this.dataset.arrows == "true" ? {
          nextEl: this.querySelector(".hero__arrow.hero__arrow-next"),
          prevEl: this.querySelector(".hero__arrow.hero__arrow-prev"),
        } : false,
        pagination: {
          el: this.querySelector(".hero__pagination"),
          type: this.dataset.paginationType,
        },
        slidesPerView: 1,
      });
    }

    calcMarginTop() {
      const announcementBar = document.querySelector(
        ".shopify-section-group-header-group .announcement"
      );
      const announcementBarHeight = announcementBar
        ? announcementBar.offsetHeight
        : 0;

      const headerOffset =
        announcementBarHeight +
        document.querySelector(
          ".shopify-section-group-header-group.section-header"
        ).offsetHeight;

      this.style.marginTop =
        window.innerWidth > 750 ? "auto" : `${headerOffset}px`;
    }
  }

  customElements.define("hero-slider", HeroSlider);
})();
